export default __webpack_public_path__ + "static/media/Mystic's Bands of the Three Clarities.c98f99fd.jpg";